<script setup lang="ts">
import { Menu } from 'lucide-vue-next';

import { Button } from '@/components/ui/button';
import BreadcrumbNav from '@components/molecules/BreadcrumbNav.vue';
import { useSidebar } from '@composables/useSidebar';

const { toggle } = useSidebar();
</script>

<template>
  <header
    class="bg-background border-border sticky top-0 z-20 flex h-14 items-center justify-between border-b px-4 sm:px-6"
  >
    <div class="flex items-center gap-3">
      <Button variant="ghost" size="icon-sm" class="-ml-2" @click="toggle">
        <Menu />
      </Button>

      <BreadcrumbNav />
    </div>
  </header>
</template>
